module.exports = __webpack_public_path__ + "img/FixitIcons.e441eb0.svg";